import React, { useEffect, useState } from "react";
import { api, downloadPdf as downloadPdfFile } from "@/lib/api";
import { toast } from "sonner";
import { FileDown, Loader2 } from "lucide-react";

/* Descarga rápida de asistencia por grupo (Día / Semana / Mes / Año).
   Reutilizable en Dirección, Coordinación y Docente. */
export function GroupAttendanceDownload({ grades: gradesProp, restrictToGroups = false, title = "Descargar asistencia por grupo" }) {
  const [grades, setGrades] = useState(gradesProp || []);
  const [group, setGroup] = useState("");
  const [period, setPeriod] = useState("week");
  const [month, setMonth] = useState(() => new Date().toISOString().slice(0, 7));
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    if (gradesProp) { setGrades(gradesProp); return; }
    api.get("/direccion/segments").then((r) => setGrades(r.data?.grades || [])).catch(() => {});
  }, [gradesProp]);

  const dl = async () => {
    if (restrictToGroups && !group) { toast.error("Selecciona uno de tus grupos"); return; }
    setDownloading(true);
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await downloadPdfFile("/reports/group-attendance-pdf", {
        params: { grade: group, period, month: period === "month" ? month : undefined, tz },
        filename: `asistencia_${group || "grupo"}_${period}.pdf`,
      });
    } catch { toast.error("No se pudo generar el PDF"); }
    finally { setDownloading(false); }
  };

  return (
    <div className="bg-white border border-nardo-200 rounded-md" data-testid="group-attendance-download">
      <div className="px-6 py-4 border-b border-nardo-200 flex items-center gap-2">
        <FileDown className="w-4 h-4 text-navy" />
        <h2 className="font-display font-semibold text-xl text-navy">{title}</h2>
      </div>
      <div className="px-6 py-5 space-y-4">
        <p className="text-sm text-nardo-600">Genera al instante un PDF imprimible con las asistencias del grupo para el periodo elegido. Ideal para enviar o imprimir rápido.</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label className="text-[10px] uppercase tracking-[0.2em] text-nardo-500">Grupo / grado</label>
            <select value={group} onChange={(e) => setGroup(e.target.value)} data-testid="gad-group" className="mt-1 w-full border border-nardo-200 rounded-md p-2 text-sm bg-white outline-none focus:border-navy">
              <option value="">{restrictToGroups ? "Selecciona un grupo" : "Todos los grupos"}</option>
              {grades.map((g) => <option key={g.value} value={g.value}>{g.label || g.value}{g.count != null ? ` (${g.count})` : ""}</option>)}
            </select>
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.2em] text-nardo-500">Periodo</label>
            <select value={period} onChange={(e) => setPeriod(e.target.value)} data-testid="gad-period" className="mt-1 w-full border border-nardo-200 rounded-md p-2 text-sm bg-white outline-none focus:border-navy">
              <option value="today">Día (hoy)</option>
              <option value="week">Semana</option>
              <option value="month">Mes</option>
              <option value="cycle">Año (ciclo escolar)</option>
              <option value="year">Año calendario</option>
            </select>
          </div>
          {period === "month" && (
            <div>
              <label className="text-[10px] uppercase tracking-[0.2em] text-nardo-500">Mes</label>
              <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="gad-month" className="mt-1 w-full border border-nardo-200 rounded-md p-2 text-sm bg-white outline-none focus:border-navy" />
            </div>
          )}
        </div>
        <button onClick={dl} disabled={downloading} data-testid="gad-download" className="inline-flex items-center gap-2 bg-navy hover:bg-navy-light text-white px-4 py-2.5 rounded-md text-sm font-medium transition-colors disabled:opacity-50">
          {downloading ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />} Descargar PDF
        </button>
      </div>
    </div>
  );
}
